var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bviq-input-style"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"bar"}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.label))]),_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.valMsg))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }